import React from "react";

export default function Footer() {
    return (
        <footer>
            <p className="footer--text">Made with ❤ by Ashish!</p>
        </footer>
    )
}